<template>
  <v-dialog
    v-model="active"
    persistent
    transition="dialog-bottom-transition"
    style="z-index: 2000"
    max-width="360"
    scrollable
    :retain-focus="false"
  >
    <v-card
      class="text-center"
      :class="
        getTheme() == 'dark' ? 'outlined elevation-0' : 'flat elevation-0'
      "
      :style="getTheme() == 'dark' ? '' : 'border-bottom: 1px solid lightgray'"
    >
      <v-card-title
        :style="
          getTheme() == 'dark'
            ? 'background-color: #505050'
            : 'background-color: white; border-bottom: 1px solid lightgray'
        "
        :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
        class="title font-weight-regular"
      >
        <v-icon
          :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
          class="mr-3"
          medium
          >{{ icon }}</v-icon
        >
        {{ title }}
        <v-spacer></v-spacer>
        <v-btn text medium @click="clickYes" style="min-width: 0; width: 20px">
          <v-icon
            medium
            :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
            >mdi-close-box</v-icon
          >
        </v-btn>
      </v-card-title>
      <v-alert
        dense
        class="ma-2 pa-2"
        outlined
        text
        type="info"
        v-if="iType == 'item.name' && cropped"
        >{{ $t("userNewOrderBasicSelectFormatInfo") }}</v-alert
      >
      <v-card-text class="pt-6 pb-6">
        <v-list v-if="iType == 'item.name'">
          <v-list-item-group v-model="item">
            <v-list-item v-for="(item, i) in items" :key="i">
              <v-list-item-content @click="selectedItem(item.name)">
                <v-list-item-title v-text="item.name"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
        <v-list v-else-if="iType == 'item'">
          <v-list-item-group v-model="item">
            <v-list-item v-for="(item, i) in items" :key="i">
              <v-list-item-content @click="selectedItem(item)">
                <v-list-item-title v-text="item"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "dialog-select-item",
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    cropped: {
      type: Boolean,
      required: false,
    },
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    iType: {
      type: String,
      required: true,
    },
    initItems: {
      type: Array,
      required: true,
    },
    initItem: {
      required: false,
    },
  },
  computed: {
    items: {
      get: function () {
        //console.log(this.initItem);
        return this.initItems;
      },
      set: function (newValue) {
        this.$emit("selectedItem", newValue);
      },
    },
    item: {
      get: function () {
        return this.initItem;
      },
      set: function (newValue) {
        console.log(newValue);
      },
    },
  },
  methods: {
    selectedItem: function (newValue) {
      this.$emit("selectedItem", newValue);
    },
    clickYes: function () {
      this.$emit("clickYes");
    },
  },
};
</script>

<style scoped>
</style>